import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-help-modal',
  templateUrl: './video-help-modal.component.html',
  styleUrls: ['./video-help-modal.component.scss']
})
export class VideoHelpModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
